"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for the HyperLink control
         */
        var HyperLink = /** @class */ (function (_super) {
            __extends(HyperLink, _super);
            function HyperLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            HyperLink.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                // special case the skip property for links in grid
                if (this.isInGrid() && !this.isInSelectedGridRow()) {
                    this.Skip = true;
                }
                this.target = $dyn.computed(function () {
                    return $dyn.value(_this.OpenInNewWindow) ? "_blank" : "";
                });
                this.href = $dyn.computed(function () {
                    var baseUrl = $dyn.value(_this.BaseUrl);
                    var parameters = "";
                    // First paramerter is joined with a '?'.
                    var joinWith = "?";
                    var questionMarkRegEx = new RegExp("[?]", "ig");
                    // Determine if base URL already has the parameter(?) in it.
                    if (questionMarkRegEx.test(baseUrl)) {
                        joinWith = "&";
                    }
                    // Access the current class as a map to get all of the query parameters
                    var self = _this;
                    for (var i = 1; i <= 6; i++) {
                        // Make sure to touch all of these to set up the correct dependencies for this function.
                        var name_1 = $dyn.value(self["QueryParam" + i + "Name"]);
                        var value_1 = $dyn.value(self["QueryParam" + i + "Value"]);
                        if (name_1) {
                            parameters += joinWith + encodeURIComponent(name_1) + "=" + encodeURIComponent(value_1);
                            // After a parameter has been added joinWith should always be '&'.
                            joinWith = "&";
                        }
                    }
                    return baseUrl + parameters;
                });
            };
            /**
             * The click event handler
             * @param event The click event
             */
            HyperLink.prototype.clicked = function (event) {
                // Don't allow a navigation if the control isn't enabled or thier isn't url.
                if (!$dyn.value(this.Enabled) || !$dyn.value(this.href)) {
                    event.preventDefault();
                }
                // Stop propagation so the shell code doesn't do a prevent default.
                event.stopPropagation();
            };
            /**
             * The keydown event handler
             * @param event The keydown event
             */
            HyperLink.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
            };
            return HyperLink;
        }($dyn.ui.Control));
        controls.HyperLink = HyperLink;
        // Set default values on the prototype for backwards compatibility
        HyperLink.prototype.OpenInNewWindow = false;
        HyperLink.prototype.BaseUrl = "";
        HyperLink.prototype.QueryParam1Name = "";
        HyperLink.prototype.QueryParam1Value = "";
        HyperLink.prototype.QueryParam2Name = "";
        HyperLink.prototype.QueryParam2Value = "";
        HyperLink.prototype.QueryParam3Name = "";
        HyperLink.prototype.QueryParam3Value = "";
        HyperLink.prototype.QueryParam4Name = "";
        HyperLink.prototype.QueryParam4Value = "";
        HyperLink.prototype.QueryParam5Name = "";
        HyperLink.prototype.QueryParam5Value = "";
        HyperLink.prototype.QueryParam6Name = "";
        HyperLink.prototype.QueryParam6Value = "";
        $dyn.ui.addObservablePropertiesToPrototype(HyperLink.prototype, {
            Text: "",
        });
        // tslint:disable:object-literal-sort-keys
        var hyperLinkShortcuts = {
            DefaultAction: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] },
                Handler: function () {
                    if (this.element) {
                        this.element.click();
                    }
                },
                ShowToUser: false,
            },
        };
        HyperLink.prototype.Shortcuts = $dyn.extendPrototype(HyperLink.prototype.Shortcuts, hyperLinkShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=HyperLink.js.map
